"use client";

import { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Menu, X, Phone, Mail } from "lucide-react";
import { pillLinks } from "@/config/navigation";
import { site } from "@/config/site";
import { KeycapButton } from "@/components/ui/KeycapButton";

export function MobileNavDialog() {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <button
          type="button"
          aria-label="Otevřít menu"
          className="inline-flex size-10 items-center justify-center rounded-lg border border-[var(--color-hairline)] text-text-muted transition-colors duration-[var(--duration-fast)] hover:border-[var(--color-hairline-strong)] hover:text-text"
        >
          <Menu size={18} />
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[120] bg-[rgba(5,7,13,0.96)] backdrop-blur-none" />
        <Dialog.Content className="fixed inset-0 z-[121] flex flex-col bg-ink-900 px-6 py-6">
          <div className="flex items-center justify-between">
            <Dialog.Title className="mono-index text-text-muted">REJSTŘÍK</Dialog.Title>
            <Dialog.Close asChild>
              <button
                type="button"
                aria-label="Zavřít menu"
                className="inline-flex size-10 items-center justify-center rounded-lg border border-[var(--color-hairline)] text-text-muted transition-colors duration-[var(--duration-fast)] hover:border-[var(--color-hairline-strong)] hover:text-text"
              >
                <X size={18} />
              </button>
            </Dialog.Close>
          </div>

          <Dialog.Description className="sr-only">
            Navigace po sekcích stránky a kontakt.
          </Dialog.Description>

          <nav aria-label="Mobilní navigace" className="mt-10 flex flex-1 flex-col gap-1">
            {pillLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="h3-ui border-b border-[var(--color-hairline)] py-4 text-text transition-colors duration-[var(--duration-fast)] hover:text-text"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="mt-8 flex flex-col gap-3">
            <KeycapButton href="#poptavka" variant="signal" onClick={() => setOpen(false)}>
              Chci nabídku
            </KeycapButton>
            <a
              href={`mailto:${site.email}`}
              className="ghost-pill justify-center"
              onClick={() => setOpen(false)}
            >
              <Mail size={15} />
              {site.email}
            </a>
            <a href={`tel:${site.phone.replace(/\s/g, "")}`} className="ghost-pill justify-center">
              <Phone size={15} />
              {site.phone}
            </a>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
